import ProFormUploadDragger from './UploadDragger';
import { withWrap } from '../../utils/hoc';
export default withWrap(ProFormUploadDragger);
